import { createHoverColor } from '@Utils/Formatters/hoverColor'
import { convertHexToRGBA } from '@Utils/Formatters/opacityColor'
import { getContrastColor } from './../../../Utils/Formatters/constrastColor'
import { ThemeType } from './Light'
import { auxiliaries } from './theme.utils'

export const darkTheme: ThemeType = {
    isDarkMode: true,
    body: '#1A1E23',
    text: '#F3F3F3',
    toggleBorder: '#6E7F90',
    background: '#1A1E23',
    sidebarColor: '#333C45',
    headerColor: '#333C45',
    borderColor: '#4F5C68',
    colors: {
        primary: '#58BFD6',
        secondary: '#E83C78',
        tertiary: 'transparent',
        input: {
            background: '#333C45',
            focusBorder: '#58BFD6',
            border: '#6E7F90',
            label: '#C3D2DB',
            labelFocus: '#58BFD6',
            placeholder: '#A6B7C4',
            supportMessage: {
                error: '#E83C78',
                warning: '#DFA904',
                info: '#58BFD6',
                success: '#58BFD6',
            },
        },
        button: {
            primaryHover: createHoverColor('#58BFD6'),
            primaryText: getContrastColor('#58BFD6'),
            secondaryHover: createHoverColor('#E83C78'),
            secondaryText: '#fff',
            tertiaryHover: createHoverColor('transparent'),
            tertiaryText: '#F3F3F3',
        },
        table: {
            inactiveRow: convertHexToRGBA('#E83C78', 0.1),
            oddRow: 'rgba(255, 255, 255, 0.05)',
            hoverRow: 'rgba(255, 255, 255, 0.1)',
            warningRow: '#DFA904',
            dangerRow: '#E83C78',
            successRow: '#58BFD6',
        },
        container: {
            background: '#333C45',
        },
    },
    ...auxiliaries,
}
